import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div data-testid="page-not-found" className="wx-container py-24 text-center">
            <p className="wx-eyebrow">404</p>
            <h1 className="mt-2 font-serif text-5xl sm:text-6xl text-[color:var(--wx-ink)]">
                Halaman tidak ditemukan
            </h1>
            <p className="mt-4 text-[color:var(--wx-ink-muted)]">
                Link yang Anda buka mungkin sudah tidak berlaku.
            </p>
            <Link
                to="/"
                data-testid="notfound-home"
                className="wx-btn-gold mt-8 inline-flex px-6 py-3 rounded-full text-sm font-medium"
            >
                Kembali ke Beranda
            </Link>
        </div>
    );
}
